import DiscoveryForm from "@/components/discovery/DiscoveryForm";

export default function ApplyPage() {
    return <DiscoveryForm />;
}
